module.exports = __webpack_public_path__ + "static/media/Cecilia_MartInez_Sandoval.5da3915c.png";